import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
  /** Optional key override. Defaults to current pathname. */
  routeKey?: string;
}

/**
 * Smooth fade + subtle lift transition between routes.
 * Respects prefers-reduced-motion.
 */
export default function PageTransition({ children, routeKey }: PageTransitionProps) {
  const location = useLocation();
  const reduce = useReducedMotion();
  const key = routeKey ?? location.pathname;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={key}
        initial={reduce ? { opacity: 0 } : { opacity: 0, y: 8 }}
        animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
        exit={reduce ? { opacity: 0 } : { opacity: 0, y: -6 }}
        transition={{
          duration: 0.32,
          ease: [0.22, 1, 0.36, 1],
        }}
        style={{ willChange: "opacity, transform" }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
